import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

const AllCategory = () => {
    const navigate= useNavigate()
    const { data, isLoading } = useQuery('categoryMenu')

    if(isLoading) {
        return <h1>Loading...</h1>
    }
    const category = data?.data
    console.log(category)

    const redirectToCategoriesProducts = (categoryId) => {
        navigate(`/categories-products/${categoryId}`);
        // refetch()
    };
    return (
        <div>
            <div className="container grid grid-cols-3 mx-auto lg:grid-cols-5 lg:w-full bg-white my-10 shadow-md py-3 group-hover:opacity-100 group-hover:visible transition">
            {category.map(item => (
                <button onClick={() => redirectToCategoriesProducts(item?.id)} className="w-full py-3 flex items-left border border-gray-300 border-dashed hover:bg-gray-100 transition">
                    <span className="ml-6 text-gray-600 text-sm truncate w-28 text-left">{item?.name}</span>
                </button>

            ))}
            </div>
        </div>
    );
};

export default AllCategory;